import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService, CookieService } from "@obg/ngx.global";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class DepositLimitConfigService {
	constructor(
		private configService: ConfigService<ObgConfigFeAdaptiveClientCore>,
		private cookieService: CookieService
	) {}

	getDepositLimitEndpoint(): string {
		return this.configService.get(
			(x) => x.core.depositLimit.endpoints?.depositLimit,
			"v1/currentcustomerlimits/depositlimit"
		);
	}

	getUnconfirmedDepositLimitEndpoint(): string {
		return this.configService.get(
			(x) => x.core.depositLimit.endpoints?.depositLimitUnconfirmed,
			`${this.getDepositLimitEndpoint()}/unconfirmed`
		);
	}

	/**
	 * This config is under jurisdiction
	 */
	getIsReconfirmationRequired(): boolean {
		return this.configService.get((x) => x.core.depositLimit.isReconfirmationRequired, false);
	}

	/**
	 * This config is under jurisdiction
	 */
	getIsMultiDepositLimitReconfirmationEnabled(): boolean {
		return this.configService.get((x) => x.core.depositLimit.isMultiDepositLimitReconfirmationEnabled, false);
	}

	/**
	 * This config is under jurisdiction
	 */
	getIsMultiDepositLimitReconfirmationEnabled$(): Observable<boolean> {
		return this.configService.get$(
			(x) => x.core.depositLimit.isMultiDepositLimitReconfirmationEnabled ?? false,
			false
		);
	}

	/**
	 * This config is under jurisdiction
	 */
	getIsDepositLimitRequired(): boolean {
		return this.configService.get((x) => x.core.depositLimit.isDepositLimitRequired, false);
	}

	/**
	 * This config is under jurisdiction
	 */
	getIsDepositLimitRequired$(): Observable<boolean> {
		return this.configService.get$((x) => x.core.depositLimit.isDepositLimitRequired ?? false, false);
	}

	/**
	 * This config is under jurisdiction
	 */
	getIsDepositLimitRequiredWithDialog(): boolean {
		return this.configService.get((x) => x.core.depositLimit.isDepositLimitRequiredWithDialog, false);
	}

	/**
	 * This config is under jurisdiction
	 */
	isSgaDepositLimitDialogEnabled(): boolean {
		const experiments = this.cookieService.get("obg-experiments");
		return (
			this.configService.get((x) => x.core.depositLimit.isSgaDepositLimitDialogEnabled, true) ||
			!!experiments?.toLowerCase().includes("dld")
		);
	}

	/**
	 * This config is under jurisdiction
	 */
	getDepositLimitExceedMessageEnabled(): boolean {
		return this.configService.get((x) => x.core.depositLimit.depositLimitExceedMessage?.isEnabled, false);
	}

	/**
	 * This config is under jurisdiction
	 */
	getDepositLimitExceedMessageThreshold(): number {
		return this.configService.get((x) => x.core.depositLimit.depositLimitExceedMessage?.threshold, 0);
	}

	getIsDepositLimitV2Enabled(): boolean {
		return this.configService.get((x) => x.core.depositLimit.isDepositLimitV2Enabled, false);
	}
}
